module.exports = __webpack_public_path__ + "d862c07c136d2b46f80bec7debf7eb27.svg";